//Importing a better form

import React from 'react';
import serialize from 'form-serialize';
import ErrorMessenger from './error-messenger';

class Form2 extends React.Component {
    constructor(props){
        super(props);

        this.fields = {};

        this.submitted = false;
        this.defaultApplied = false;

        this.state = {
            errors: props.submitErrors || false,
            error: props.submitError || false,
            valid: false,
            data: {}
        }
    }

    componentWillReceiveProps(props) {
        this.setErrorsFromProps(props);
        this.applyDefault(props);
    }

    componentWillMount() {
        this.submitted = false;
        this.setErrorsFromProps(this.props);
    }

    componentDidMount() {
        this.updateState();
        this.applyDefault(this.props);
    }

    applyDefault(props = this.props) {
        if (typeof props.defaultValues === 'object' && Object.keys(props.defaultValues).length > 0 && !this.defaultApplied) {
            this.data = props.defaultValues;
            this.defaultApplied = true;
        }
    }

    setErrorsFromProps(props = this.props) {
        if (props.submitError && props.submitError.length > 0) {
            this.setState({
                error: props.submitError
            });
        }

        if (props.submitErrors) {
            this.setState({
                errors: Object.assign({}, this.state.errors, props.submitErrors)
            });
        }
    }

    getErrors(props = this.props) {

        let errors = props.submitErrors || {};

        if (this.refs.formElement) {
            for (var i = 0; i < this.refs.formElement.elements.length; i++) {
                let element = this.refs.formElement.elements[i];
                if (!element.validity.valid) {
                    errors[element.name] = element.validationMessage;
                }
            }
        }

        Object.keys(this.fields).forEach(key => {
            let field = this.fields[key];
            if (field.error) {
                errors[key] = field.error;
            }
        });

        return errors;
    }

    getError() {

        let errors = this.getErrors();
        let firstError = Object.keys(errors)[0];

        return errors[firstError] || false;
    }

    get defaultData() {
        return this.props.defaultValues || {};
    }

    get data(){
        let organicData = serialize(this.refs.formElement, { hash: true });
        let data = {};
        Object.keys(this.fields).forEach(key => {
            let field = this.fields[key];

            if (field.valid) {
                data[field.props.name] = this.fields[field.props.name].value;
            }
        });

        return Object.assign({}, organicData, data);
    }

    set data(data) {
        Object.keys(data).forEach(key => {
            let value = data[key];
            let ref = this.fields[key] || this.refs[key];
            if (ref) {
                if (typeof ref.setValue === 'function') {
                    ref.setValue(value);
                }
            }
        });

        this.updateState();
    }

    get valid() {
        return this.refs.formElement.checkValidity() && Object.keys(this.fields).every(key => {
            let field = this.fields[key];
            return (typeof field.valid === 'boolean') && field.valid;
        });
    }

    registerErrorMessenger(component){
        if (component.props.global) {
            this.globalErrorMessenger = component;

            return () => {
                delete this.globalErrorMessenger;
            }
        } else {
            if (!component.props.fieldName) {
                console.error('Can\'t register an error messenger without a fieldName');
                return;
            }

            this.errorMessengers[component.props.fieldName] = component;

            return () => {
                delete this.errorMessengers[component.props.fieldName];
            }
        }
    }

    registerField(field) {
        if (!field.props.name) {
            throw new Error('Can\'t add a field without a name to a Form.');
        }

        this.fields[field.props.name] = field;

        return () => {
            delete this.fields[field.props.name];
        }
    }

    updateState(props = this.props) {
        if (!this.refs.formElement) {
            return;
        }
        if (this.submitted || this.props.waitForSubmit === false) {
            this.setState({
                errors: this.getErrors(props),
                error: this.getError(props),
                valid: this.valid,
                data: this.data
            });
        }
    }

    submit() {
        this.refs.formElement.dispatchEvent(new CustomEvent('submit', {
            cancelable: true,
            bubbles: true
        }));
    }

    change(event) {
        this.handleChange(event);
    }

    handleError(event) {
        if ( typeof this.props.onError === 'function') {
            this.props.onError(event, this.getErrors(), this);
        }

        this.updateState();
    }

    handleChange(event) {

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(event, this.data, this.getErrors(), this);
        }

        if (this.submitted || this.props.waitForSubmit === false) {
            this.updateState();
        }

        this.handleDirty(event);
        this.handleAutoSubmit(event);
    }

    handleDirty(event) {
        if (typeof this.props.onDirty === 'function') {
            this.props.onDirty(event, this.data, this.getErrors(), this);
        }
    }

    handleAutoSubmit(event) {
        if (!this.props.autoSubmit) {
            return;
        }

        if (this.autoSubmitter) {
            clearTimeout(this.autoSubmitter);
        }

        this.autoSubmitter = setTimeout(() => {
            if (typeof this.props.onAutoSubmit === 'function') {
                this.props.onAutoSubmit(event, this.data, this.getErrors(), this)
            }
            this.updateState();
        }, 500);
    }

    handleSubmit(event) {
        this.submitted = true;
        event.preventDefault();
        if (!this.valid) {
            this.handleError(event);
        } else if (typeof this.props.onSubmit === 'function') {
            this.props.onSubmit(event, this.data, this.getErrors(), this);
        }
        return false;
    }

    renderElement(element, key){
        if (Array.isArray(element)) {
            return element.map((child, i) => {
                return this.renderElement(child, i);
            });
        } else if(React.isValidElement(element)){
            let children = React.Children.map(element.props.children, (child, i) => {
                return this.renderElement(child, i);
            });

            let newProps = {
                children,
                key,
                ref: element.props.name
            }

            if (typeof element !== 'string') {
                if (element.props.name) {
                    newProps.form = this;

                    if (this.defaultData[element.props.name]) {
                        newProps.defaultValue = this.defaultData[element.props.name];
                    }
                }
            }

            if (element.type === ErrorMessenger) {
                newProps.form = this;

                if (element.props.global) {
                    newProps.errorMessage = this.state.error;
                } else if (element.props.fieldName) {
                    newProps.errorMessage = this.state.errors[element.props.fieldName];
                }
            }

            return React.cloneElement(element, newProps);
        } else {
            return element;
        }
    }

    render () {
        return (
            <form {...this.props} ref="formElement" action="javascript:void(0);" onSubmit={e => this.handleSubmit(e)} onChange={e => this.handleChange(e)} className={['component-form', this.props.className].join(' ')} noValidate>
                { this.renderElement(this.props.children) }
            </form>
        )
    }
}

export default Form2;



// WEBPACK FOOTER //
// ./web-app/components/form2.jsx